import { DenialLetterUploadStatus } from "../../../../enums/denialLetterUploadStatus";

export const allLetterUploadOptions = [
  { label: "Started", value: DenialLetterUploadStatus.INITIATED },
  { label: "In Progress", value: DenialLetterUploadStatus.IN_PROGRESS },
  {
    label: "Letter Not Found",
    value: DenialLetterUploadStatus.LETTER_NOT_FOUND,
  },
  { label: "Success", value: DenialLetterUploadStatus.SUCCESS },
  { label: "Error", value: DenialLetterUploadStatus.ERROR },
  { label: "NA", value: DenialLetterUploadStatus.NA },
];
